import React from 'react';

import { Typography, Button } from '@mui/material';
import './SharedButtons.scss';

type Props = {
  isLoading: boolean;
  type: 'CPT' | 'HCPCS';
  openAddCodePopup: (type: 'CPT' | 'HCPCS' | undefined) => void;
  dark: boolean;
};

const AddManualCodeButton: React.FC<Props> = ({
  isLoading,
  type,
  openAddCodePopup,
  dark,
}) => {
  return (
    <Button
      disabled={isLoading}
      onClick={() => openAddCodePopup(type)}
      className='add-cpt-code-button'
      sx={{
        borderRadius: '50px',
      }}
      color={dark ? 'darkBlue' : 'primary'}
      variant='contained'
      disableElevation
    >
      <Typography noWrap color='white'>
        Add {type} code
      </Typography>
    </Button>
  );
};

export default AddManualCodeButton;
